/**
 *
 * NotFound
 *
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'react-bootstrap';
import messages from './messages.js';

function NotFound(props) {
  const { setMeta } = props;
  const title = messages.notFoundTitle;
  const description = messages.notFoundDescription;
  const pageTitle = title;
  useEffect(() => setMeta({ title, description, pageTitle }), []);
  return <Alert variant="danger" className="alert-shaded"><FormattedMessage {...messages.notFoundDescription} /></Alert>;
}

NotFound.propTypes = {
  setMeta: PropTypes.func.isRequired,
};

export default NotFound;
